<div class="kanban-card-wrapper" *ngIf="outcomeType == 'quarterly'">
  <div class="card-header m-b-10">
    <div class="theme-wrapper">
      <div
        class="theme-color"
        [style.background-color]="kanbanData?.annual_outcome?.theme?.color"
      ></div>
      <div
        class="theme-name caption text-80 text-overflow of-hidden space-nowrap"
        ngbTooltip="{{ kanbanData?.annual_outcome?.theme?.value }}"
      >
        {{ kanbanData?.annual_outcome?.theme?.value }}
      </div>
    </div>
  </div>
  <div class="card-content">
    <p
      class="b2 text-100 m-b-0 multiline-ellipsis"
      ngbTooltip="{{ kanbanData?.value }}"
    >
      {{ kanbanData?.value }}
    </p>
  </div>
  <div class="card-footer">
    <div class="member-avatar">
      @if(kanbanData?.user){ @if(kanbanData?.user?.avatar){
      <p-avatar
        class="outcome-dependency-avatar p-avatar-square m-r-5"
        image="{{
          kanbanData?.user?.avatar
            ? kanbanData?.user?.avatar
            : kanbanData?.quarterly?.user?.avatar
        }}"
        ngbTooltip="{{
          kanbanData?.user?.name
            ? kanbanData?.user?.name
            : kanbanData?.quarterly?.user?.name
        }}"
      />
      } @else {
      <p-avatar
        class="outcome-dependency-avatar p-avatar-square m-r-5"
        image="{{ env.assetUrl }}/user_placeholder.png"
        ngbTooltip="{{
          kanbanData?.user?.name
            ? kanbanData?.user?.name
            : kanbanData?.quarterly?.user?.name
        }}"
      />
      } }
    </div>
    <div class="status">
      <div class="status-type caption text-60">Milestones</div>
      @if(kanbanData?.milestones?.length){
      <div class="status-count">
        <span
          *ngIf="milestoneCounts[1] > 0"
          class="not-started-count b3 text-10 font-medium"
          [ngStyle]="{ 'background-color': getMilestoneColor(1) }"
        >
          {{ milestoneCounts[1] }}
        </span>
        <span
          *ngIf="milestoneCounts[2] > 0"
          class="not-started-count b3 text-10 font-medium"
          [ngStyle]="{ 'background-color': getMilestoneColor(2) }"
        >
          {{ milestoneCounts[2] }}
        </span>
        <span
          *ngIf="milestoneCounts[3] > 0"
          class="not-started-count b3 text-10 font-medium"
          [ngStyle]="{ 'background-color': getMilestoneColor(3) }"
        >
          {{ milestoneCounts[3] }}
        </span>
        <span
          *ngIf="milestoneCounts[4] > 0"
          class="not-started-count b3 text-10 font-medium"
          [ngStyle]="{ 'background-color': getMilestoneColor(4) }"
        >
          {{ milestoneCounts[4] }}
        </span>
        <span
          *ngIf="milestoneCounts[5] > 0"
          class="not-started-count b3 text-10 font-medium"
          [ngStyle]="{ 'background-color': getMilestoneColor(5) }"
        >
          {{ milestoneCounts[5] }}
        </span>
      </div>

      } @if(kanbanData?.quarterly?.length>0){
      <div class="status-count">
        <span
          *ngIf="milestoneCounts[1] > 0"
          class="not-started-count b3 text-10 font-medium"
          [ngStyle]="{ 'background-color': getMilestoneColor(1) }"
        >
          {{ milestoneCounts[1] }}
        </span>
        <span
          *ngIf="milestoneCounts[2] > 0"
          class="not-started-count b3 text-10 font-medium"
          [ngStyle]="{ 'background-color': getMilestoneColor(2) }"
        >
          {{ milestoneCounts[2] }}
        </span>
        <span
          *ngIf="milestoneCounts[3] > 0"
          class="not-started-count b3 text-10 font-medium"
          [ngStyle]="{ 'background-color': getMilestoneColor(3) }"
        >
          {{ milestoneCounts[3] }}
        </span>
        <span
          *ngIf="milestoneCounts[4] > 0"
          class="not-started-count b3 text-10 font-medium"
          [ngStyle]="{ 'background-color': getMilestoneColor(4) }"
        >
          {{ milestoneCounts[4] }}
        </span>
        <span
          *ngIf="milestoneCounts[5] > 0"
          class="not-started-count b3 text-10 font-medium"
          [ngStyle]="{ 'background-color': getMilestoneColor(5) }"
        >
          {{ milestoneCounts[5] }}
        </span>
      </div>
      }
    </div>
  </div>
</div>

<div class="kanban-card-wrapper" *ngIf="outcomeType == 'annual'">
  <div class="card-header m-b-10">
    <div class="theme-wrapper">
      <div
        class="theme-color"
        [style.background-color]="kanbanData?.theme?.color"
      ></div>
      <div
        class="theme-name caption text-80 text-overflow of-hidden space-nowrap"
        ngbTooltip="{{ kanbanData?.theme?.value }}"
      >
        {{ kanbanData?.theme?.value }}
      </div>
    </div>
    <!-- visible on Annual toggle and only on Delayed column -->
    <!-- <div class="alert-icon-wrapper"><ng-icon class="lh-1-0" name="hugeAlert02" size="16" /></div> -->
  </div>
  <div class="card-content">
    <p
      class="b2 text-100 m-b-0 multiline-ellipsis"
      ngbTooltip="{{ kanbanData?.value }}"
    >
      {{ kanbanData?.value }}
    </p>
  </div>
  <div class="card-footer">
    <div class="member-avatar">
      @if(kanbanData?.outcome_type == 'individual'){ 
        @if(kanbanData?.user?.avatar){
          <p-avatar
            class="outcome-dependency-avatar p-avatar-square m-r-5"
            image="{{ kanbanData?.user?.avatar }}"
            ngbTooltip="{{ kanbanData?.user?.name }}"
          />
        } @else {
          <p-avatar
            class="outcome-dependency-avatar p-avatar-square m-r-5"
            image="{{ env.assetUrl }}/user_placeholder.jpg"
            ngbTooltip="{{ kanbanData?.user?.name }}"
          />
        } 
      }
      @else if(kanbanData?.members?.length>0){
      <p-avatarGroup>
        <p-avatar
          *ngFor="let member of kanbanData?.members.slice(0, 2)"
          class="outcome-dependency-avatar p-avatar-square"
          image="{{
            member.detail?.avatar ? member.detail?.avatar : helper.defaultImageUrl
          }}"
          ngbTooltip="{{ member.detail.name }}"
        ></p-avatar>
        <p-avatar
          *ngIf="kanbanData?.members.length > 2"
          type="button"
          class="avatar-count p-avatar-square"
          [label]="'+' + (kanbanData?.members.length - 2)"
          [ngbPopover]="membersPopover"
          popoverClass="avatar-group-popover"
          container="body"
        ></p-avatar>
        <ng-template #membersPopover>
          <div
            *ngFor="
              let member of kanbanData?.members.slice(
                2,
                kanbanData?.members.length
              )
            "
            class="dis-flex flex-m m-b-8 align-items-center"
          >
            <div class="">
              <p-avatar
                class="outcome-dependency-avatar p-avatar-square m-r-5"
                [image]="member.detail.avatar || helper.defaultImageUrl"
              ></p-avatar>
              <div class="dependency-person">
                <p
                  class="b3 font-medium text-100 m-b-0 lh-1-5 of-hidden text-overflow space-nowrap"
                  ngbTooltip="{{ member.detail.name }}"
                >
                  {{ member.detail.name }}
                </p>
                <p
                  class="b3 text-60 m-b-0 lh-1-5 of-hidden text-overflow space-nowrap"
                  ngbTooltip="{{ member.detail.designation || 'N/A' }}"
                >
                  {{ member.detail.designation || "N/A" }}
                </p>
              </div>
            </div>
          </div>
        </ng-template>
      </p-avatarGroup>
      }
    </div>
    <div class="status" *ngIf="this.category != 'affiliate'">
      <div class="status-type caption text-60" ngbTooltip="Short Term Outcomes">STO </div>
      @if(kanbanData?.milestones?.length){
      <div class="status-count">
        <span
          *ngIf="milestoneCounts[1] > 0"
          class="not-started-count b3 text-10 font-medium"
          [ngStyle]="{ 'background-color': getMilestoneColor(1) }"
        >
          {{ milestoneCounts[1] }}
        </span>
        <span
          *ngIf="milestoneCounts[2] > 0"
          class="not-started-count b3 text-10 font-medium"
          [ngStyle]="{ 'background-color': getMilestoneColor(2) }"
        >
          {{ milestoneCounts[2] }}
        </span>
        <span
          *ngIf="milestoneCounts[3] > 0"
          class="not-started-count b3 text-10 font-medium"
          [ngStyle]="{ 'background-color': getMilestoneColor(3) }"
        >
          {{ milestoneCounts[3] }}
        </span>
        <span
          *ngIf="milestoneCounts[4] > 0"
          class="not-started-count b3 text-10 font-medium"
          [ngStyle]="{ 'background-color': getMilestoneColor(4) }"
        >
          {{ milestoneCounts[4] }}
        </span>
        <span
          *ngIf="milestoneCounts[5] > 0"
          class="not-started-count b3 text-10 font-medium"
          [ngStyle]="{ 'background-color': getMilestoneColor(5) }"
        >
          {{ milestoneCounts[5] }}
        </span>
      </div>

      } @if(kanbanData?.quarterly?.length>0){
      <div class="status-count">
        <span
          *ngIf="milestoneCounts[1] > 0"
          class="not-started-count b3 text-10 font-medium"
          [ngStyle]="{ 'background-color': getMilestoneColor(1) }"
        >
          {{ milestoneCounts[1] }}
        </span>
        <span
          *ngIf="milestoneCounts[2] > 0"
          class="not-started-count b3 text-10 font-medium"
          [ngStyle]="{ 'background-color': getMilestoneColor(2) }"
        >
          {{ milestoneCounts[2] }}
        </span>
        <span
          *ngIf="milestoneCounts[3] > 0"
          class="not-started-count b3 text-10 font-medium"
          [ngStyle]="{ 'background-color': getMilestoneColor(3) }"
        >
          {{ milestoneCounts[3] }}
        </span>
        <span
          *ngIf="milestoneCounts[4] > 0"
          class="not-started-count b3 text-10 font-medium"
          [ngStyle]="{ 'background-color': getMilestoneColor(4) }"
        >
          {{ milestoneCounts[4] }}
        </span>
        <span
          *ngIf="milestoneCounts[5] > 0"
          class="not-started-count b3 text-10 font-medium"
          [ngStyle]="{ 'background-color': getMilestoneColor(5) }"
        >
          {{ milestoneCounts[5] }}
        </span>
      </div>
      }
    </div>
  </div>
</div>
